import {
  BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer
} from 'recharts';

export default function EngagementChart({ reports }) {
  return (  
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={reports}>
        <XAxis dataKey="year_month" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="count" fill="red" />
      </BarChart>
    </ResponsiveContainer>
  );
}
